import React, { Component } from "react";
import axios from "../../util/axios";

class ReportJob extends Component {
  constructor(props) {
    super(props);
  }
  state = {
    jobId: this.props.match ? this.props.match.params.jobId : ""
  };

  componentDidMount() {
    console.log(localStorage.getItem("reportProps"));

    const timer = setInterval(() => {
      axios
        .get("/api/report/job/status/" + this.state.jobId, {
          headers: {
            Authorization: JSON.parse(localStorage.getItem("userData")).token,
            "Cobrand-Id": this.state.cobrandId
          }
        })
        .then(res => {
          const reportsViewData = res.data.status;
          console.log(res);
          if (res.data.status === "COMPLETED") {
            clearInterval(timer);
            this.setState({ jobStatus: "created" });
            this.setState({ reportId: res.data.id });
            this.props.history.push({
              pathname:
                "/reportsView/" + res.data.id + "/" + res.data.reportConfig.id,
              reportProps: {
                selectedDuration: localStorage.getItem("selectedDuration")
              }
            });
          }
          console.log(res.data.status);
        })
        .catch(err => {
          console.log(err);
        });
    }, 1000);
  }

  render() {
    return (
      <React.Fragment>
        <div className="container">
          <div style={{ position: "fixed", top: "50%", left: "50%" }}>
            <span className="spinner-border text-primary" role="status"></span>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ReportJob;
